import type { TOC } from '@ember/component/template-only';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';

interface SettingsHotelAccessFormsCellHeaderSignature {
  Args: {
    column: unknown;
  };
}

const SettingsHotelAccessFormsCellHeader = <template>
  {{! @glint-nocheck: not typesafe yet }}
  {{! https://ihatetomatoes.net/firefox-issue-with-foundation-and-vertical-alignment/ }}
  <div class="settings-header-cell" title={{@column.name}}>
    <div class="flex items-center">
      {{@column.name}}
      {{#if @column.tooltip}}
        <span class="ml-100">
          <GeneralIconWithTooltip
            @side="top"
            @tooltipContent={{@column.tooltip}}
          />
        </span>
      {{/if}}
    </div>
  </div>
</template> satisfies TOC<SettingsHotelAccessFormsCellHeaderSignature>;

export default SettingsHotelAccessFormsCellHeader;
